  <!-- Modal de selección de sesión -->
  <div *ngIf="view.showSessionModal" class="modal-backdrop show chat-session-backdrop" appAppendToBody
    style="z-index: 1050;"></div>
  <div *ngIf="view.showSessionModal" class="modal d-block fade show custom-session-modal" appAppendToBody tabindex="-1">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" style="color: var(--text-primary); font-weight: 700; letter-spacing: 0.5px;">
            <i class="fas fa-history me-2" style="color: var(--primary);"></i> {{ view.sessionModalTitle }}
          </h5>
          <button type="button" class="btn-close btn-close-white" aria-label="Cerrar"
            (click)="view.showSessionModal = false"></button>
        </div>
        <div class="modal-body session-modal-body">
          <div *ngIf="view.sessionList.length === 0" class="text-center py-4">
            <i class="fas fa-inbox fa-2x mb-2" style="color: var(--primary);"></i>
            <div>{{ view.translate('chat.no_sessions') || view.translate('chat.no_previous_sessions') }}</div>
          </div>
          <ul class="list-group list-group-flush" *ngIf="view.sessionList.length > 0">
            <li *ngFor="let session of view.sessionList" class="list-group-item list-group-item-action session-list-item"
              [ngClass]="{'active': view.selectedSessionId === session.session_id}"
              (click)="view.selectedSessionId = session.session_id || null" (dblclick)="view.changeName(session)"
              [attr.title]="session.content">
              <div class="fw-bold">
                <ng-container *ngIf="view.editingSessionId === session.session_id; else showName">
                  <div class="session-edit-row">
                    <input id="session-edit-input-{{session.session_id}}" type="text"
                      class="form-control form-control-sm session-edit-input"
                      [ngClass]="{'is-invalid': view.sessionNameError}" [(ngModel)]="view.editingSessionName"
                      (click)="$event.stopPropagation()"
                      (keydown.enter)="view.saveSessionName(session)" (blur)="view.saveSessionName(session)"
                      (keydown.escape)="view.cancelEditSessionName()" />
                    <button type="button" class="session-icon-btn session-icon-btn--confirm"
                      [title]="view.translate('chat.save')" [attr.aria-label]="view.translate('chat.save')"
                      (mousedown)="$event.preventDefault()"
                      (click)="$event.stopPropagation(); view.saveSessionName(session)">
                      <i class="fas fa-check"></i>
                    </button>
                    <button type="button" class="session-icon-btn session-icon-btn--cancel"
                      [title]="view.translate('chat.cancel')" [attr.aria-label]="view.translate('chat.cancel')"
                      (mousedown)="$event.preventDefault()"
                      (click)="$event.stopPropagation(); view.cancelEditSessionName()">
                      <i class="fas fa-times"></i>
                    </button>
                  </div>
                  <div *ngIf="view.sessionNameError" class="invalid-feedback" style="display:block;">{{
                    view.translate('chat.session_name_empty_error') }}</div>
                </ng-container>
                <ng-template #showName>
                  <div class="session-name-row">
                    <span class="session-name-text">{{ session.conversation_name || view.translate('chat.session_untitled') }}</span>
                    <button type="button" class="session-icon-btn session-rename-btn"
                      [title]="view.translate('chat.rename')" [attr.aria-label]="view.translate('chat.rename')"
                      (click)="$event.stopPropagation(); view.changeName(session)">
                      <i class="fas fa-pen"></i>
                    </button>
                  </div>
                </ng-template>
                <div *ngIf="view.showSessionNameSuccess === session.session_id"
                  class="alert alert-success py-1 px-2 mt-1 mb-0" style="font-size: 0.95em; display:inline-block;">
                  <i class="fas fa-check-circle me-1"></i>{{view.translate('chat.message_change_name_success')}}
                </div>
              </div>
              <div class="text-muted small mt-1">{{ session.content | slice:0:60 }}{{ session.content &&
                session.content.length > 60 ? '...' : '' }}</div>
            </li>
          </ul>
        </div>
        <div class="modal-footer d-flex justify-content-between">
          <button class="btn btn-primary px-4" [disabled]="!view.selectedSessionId" (click)="view.onSessionRecover()">
            <i class="fas fa-undo me-1"></i> {{ view.translate('chat.recover') }}
          </button>
          <button class="btn btn-outline-secondary px-4" (click)="view.onNewSession()">
            <i class="fas fa-plus me-1"></i> {{ view.translate('chat.new_session') }}
          </button>
          <button class="btn btn-danger px-4" (click)="view.onCloseEvent()">
            <i class="fas fa-times me-1"></i> {{ view.translate('chat.close') }}
          </button>
        </div>
      </div>
    </div>
  </div>
